const onEnter = onClick => ({ key }) => {
  if (key === "Enter") {
    onClick();
  }
};

module.exports = { onEnter };



// WEBPACK FOOTER //
// ./utils/Accessability.js